import Header from "../../header/Header";
import Signature from "../for_signature/Signature";
import Footer from "../../footer/Footer";


function SignatureLanding(){
    return(
        <div className="signature_landing">
            <Header />
            <Signature />
            <Footer />
        </div>
    )
}

export default SignatureLanding